import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const languageSlice = createSlice({
  name: "appConfig",
  initialState: { language: null as string | null },
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
  },
});

export const { setLanguage } = languageSlice.actions;
